import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import CustomAppBar from "../../components/AppBar";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "100vh",
    marginBottom: theme.spacing(-4),
  },
  container: {
    padding: theme.spacing(3),
    maxWidth: "1200px",
    margin: "0 auto",
  },
}));

export default function FranchisePayouts() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.root} component={Paper}>
      <CustomAppBar />

      <Box className={classes.container}>
        <Typography variant="h4">{t("Your Payouts")}</Typography>

        <Typography variant="h6">
          {t("You do not have any payouts currently")}
        </Typography>
        {/* TODO: Add payout listing */}
      </Box>
    </Box>
  );
}
